import React from 'react'

const Loading = (props) => {
    return (
        <div>Loading</div>
    )
}

export default Loading